
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brands",
      function () {
        return require("private-next-pages/brands/index.page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brands"])
      });
    }
  